import React from "react";

const Frontend = () => {
  return <h1>Frontend page content</h1>;
};

export default Frontend;